const shouldIncludeTeamIdsByDefault = (sport) => {
  if (!sport) return true;
  return sport.toLowerCase() !== 'nba';
};

const SPORT_PROMPTS = {
  baseball: (gameData) => `
    BASEBALL GAME (e.g. MLB): ${gameData.homeTeam} vs ${gameData.awayTeam}

    Give EXACTLY 5 safe high confidence Baseball bets. Be EXTREMELY CONCISE. Dont guess. Use real stats to decide.
    Format:
    1. [Bet Type]: [Pick] - [XX.X%] [HIGH/MED/LOW]

    MUST include numeric confidence (e.g., 72.5%, 68.3%) based on logical feature selection model.
    Focus: Alternative Run Lines (0.5, 1.5 for safer spreads), Total Runs, First 5 Innings, Team Total Runs, Safe Player Props (hits, strikeouts, home runs - NO assists, goals, touchdowns, or other sport stats)
    NO long explanations. Just the 5 bets with percentages.
    
    <Backend Tool Rule>
    Use your get_basketball_odds EVERYTIME.
    <Backend Tool Rule/>
  `,

  football: (gameData) => `
    FOOTBALL/SOCCER GAME (e.g. Premier League, La Liga, Champions League): ${gameData.awayTeam} @ ${gameData.homeTeam}
    Home Team ID: ${gameData.homeTeamId}, Away Team ID: ${gameData.awayTeamId}, League ID: ${gameData.leagueId}

    Give EXACTLY 4 safe high confidence Football/Soccer bets. Be EXTREMELY CONCISE in format. Dont guess. Use real stats to decide. For example, don't just say o/u "2.5" goals. think!!!
    Format:
    1. [Bet Type]: [Pick] - [XX.X%] [HIGH/MED/LOW]

    MUST look up team in order to find stats and form. MUST include numeric confidence (e.g., 72.5%, 68.3%) based on logical feature selection model.
    Focus: Match Result, Double Chance (e.g. Home/Draw), Draw No Bet, safer Over/Under Goals (Under 3.5 Goals), Asian Handicap (NO touchdowns, yards, assists, or other sport stats)
    NO long explanations. Just the 4 bets with percentages.
  `,

  nfl: (gameData) => `
    AMERICAN FOOTBALL (NFL) GAME: ${gameData.homeTeam} vs ${gameData.awayTeam}
    Home Team ID: ${gameData.homeTeamId}, Away Team ID: ${gameData.awayTeamId}, League ID: ${gameData.leagueId}

    Give EXACTLY 5 safe high confidence NFL (American Football) bets. Be EXTREMELY CONCISE. Dont guess. Use real stats to decide.

    CRITICAL FORMAT - Use EXACTLY this format with colon after bet type:
    1. Alt Total Points: Over 39.5 - 72.8% HIGH
    2. Alt Spread: Denver +4.5 - 71.3% HIGH
    3. Team Total: Buffalo Over 19.5 - 70.4% HIGH

    Format Instructions:
    DO NOT use reversed format like "Denver +4.5 (alt spread)".
    ALWAYS use "Bet Type: Selection - XX.X% CONF" format.

    Format: [Number]. [Bet Type]: [Selection] - [XX.X%] [HIGH/MED/LOW]

    MUST look up team stats and recent performance. MUST include numeric confidence (e.g., 72.5%, 68.3%) based on logical feature selection model.
    Focus: safe-ish alternative Spread, Total Points, First Half, Alt Spread, Player Props (passing yards, rushing yards, touchdowns - NO assists or basketball stats)
    NO long explanations. Just the 5 bets with percentages.

    <fallback>
    If data is unavailable or tools fail, STILL PROVIDE 5 PICKS.
    Use general knowledge, historical trends, and logical inference.
    Mark confidence 65-70% [override].
    An educated guess beats an empty response — especially for big games - to keep customers around.
    </fallback>


  `,

  ncaaf: (gameData) => `
    AMERICAN FOOTBALL (NCAA College) GAME: ${gameData.homeTeam} vs ${gameData.awayTeam}
    Home Team ID: ${gameData.homeTeamId}, Away Team ID: ${gameData.awayTeamId}, League ID: ${gameData.leagueId}

    Give EXACTLY 5 best NCAAF (College American Football) bets. Be EXTREMELY CONCISE. Dont guess. Use real stats to decide.
    Format:
    1. [Bet Type]: [Pick] - [XX.X%] [HIGH/MED/LOW]

    MUST look up team stats and recent performance. MUST include numeric confidence (e.g., 72.5%, 68.3%) based on logical feature selection model.
    Focus: Spread, Total Points, First Half, Team Totals, Player Props (passing/rushing yards, touchdowns - NO assists or basketball stats)
    NO long explanations. Just the 5 bets with percentages.
  `,

  nba: (gameData, options = {}) => `
    BASKETBALL (NBA) GAME: ${gameData.awayTeam} @ ${gameData.homeTeam}
${options.includeTeamIds === false ? '' : `    Home Team ID: ${gameData.homeTeamId}, Visitors Team ID: ${gameData.visitorsTeamId}, League ID: ${gameData.leagueId}\n`}

    Give EXACTLY 5 safe high confidence NBA (Basketball) bets. Be EXTREMELY CONCISE. Dont guess. Use real stats to decide.

    CONFIDENCE FLOOR: Seek recommend plays at 70-82%+ confidence. We want WINNERS.
    RISK APPROACH: Smart value, not scared money.
    - Alt spreads 4-8+ pts off market for cushion based on your analysis.

    Format:
    1. [Bet Type]: [Pick] - [XX.X%] [HIGH/MED/LOW]

    MUST look up team in order to find rostered player. MUST include numeric confidence (e.g., 72.5%, 68.3%) based on logical feature selection model.
    Focus: safer high confidence alt Spread, Total Points, Player Props (points, rebounds, assists - basketball stats only), First Half, Team Totals
    NO long explanations. Just the 5 bets with percentages.
  `,

  nhl: (gameData) => `
    HOCKEY GAME (e.g. NHL): ${gameData.awayTeam} @ ${gameData.homeTeam}
    Home Team ID: ${gameData.homeTeamId}, Away Team ID: ${gameData.awayTeamId}, League ID: ${gameData.leagueId}

    The year is 2026 and the season is 2025-2026.

    Give EXACTLY 5 safe high confidence Hockey bets. Be EXTREMELY CONCISE. Don't guess. Use real stats to decide.
    CONFIDENCE FLOOR: Only recommend plays at 75%+ confidence. We want WINNERS.
    RISK APPROACH: Smart value, not scared money.
    - Puck line underdogs (+1.5) on competitive matchups
    - Totals backed by goalie stats and recent scoring
    - Team totals when one side has clear offensive edge
    - AVOID: Heavy ML favorites (-200+), cold goalies, B2B situations

    Format EXACTLY like this:
    1. [Bet Type]: [Pick] - XX.X% HIGH/MED/LOW
    2. [Bet Type]: [Pick] - XX.X% HIGH/MED/LOW

    Example: Moneyline: Red Wings - 72.5% HIGH

    MUST look up team stats and recent performance. MUST include numeric confidence (e.g., 72.5%, 68.3%) based on logical feature selection model.
    Focus: safe Moneyline, safer Total Goals (Over/Under based on data), Puck Line (based on data), First Period, Team Total Goals, Player Props (goals, assists, saves - hockey stats only, NO touchdowns, runs, or other sport stats)
    NO long explanations. Just the 5 bets with percentages and ALWAYS use colon after bet type.
  `,

  default: (gameData) => `
    ${gameData.homeTeam} vs ${gameData.awayTeam}

    Give EXACTLY 5 safe leaning alternative spread or point bets. Be EXTREMELY CONCISE. 

    CONFIDENCE FLOOR: Only recommend plays at 75%+ confidence. We want WINNERS.
    RISK APPROACH: Alt lines for cushion, totals with data backing, avoid straight chalk.

    Format:
    1. [Bet Type]: [Pick] - [XX.X%] [HIGH/MED/LOW]

    MUST include numeric confidence percentage based on logical feature selection model.
    Focus: safer bets. NO long explanations. Just the 5 bets with percentages.
  `
};

export const getMultiplasPrompt = (gameData, sport, options = {}) => {
  const sportLower = sport.toLowerCase();
  const promptGenerator = SPORT_PROMPTS[sportLower] || SPORT_PROMPTS.default;
  const includeTeamIds = options.includeTeamIds ?? shouldIncludeTeamIdsByDefault(sport);

  return promptGenerator(gameData, { includeTeamIds });
};

export const SUPPORTED_SPORTS = Object.keys(SPORT_PROMPTS).filter(s => s !== 'default');
